export default {
  wallet: 'کیف پول',
  deposit: 'افزایش موجودی',
  withdraw: 'برداشت',
  withdrawalBalance: 'موجودی قابل برداشت',
  yourWalletBalance: 'موجودی کیف پول شما',
  pleaseWriteTheAmountYouWantToWithdraw:
    'لطفا مبلغ مورد نظر خود جهت برداشت را بنویسید',
  pleaseSelectTheDestinationBank: 'لطفا بانک مقصد را انتخاب کنید',
  bankAccount: 'حساب بانکی',
  pleaseSelectWithdrawType: 'نوع برداشت خود را انتخاب کنید',
  fast: 'آنی',
  normal: 'عادی',
  wage: 'مبلغ کارمزد',
  autoCharge: 'شارژ خودکار',
  daily: 'روزانه',
  weekly: 'هفتگی',
  monthly: 'ماهانه',
  autoChargeDaily: 'شارژ خودکار به صورت روزانه انجام خواهد شد',
  autoChargeWeeklyOn_day_:
    'شارژ خودکار در روز {day} به صورت هفتگی انجام خواهد شد',
  autoChargeMonthlyOn_day_:
    'شارژ خودکار در روز {day} به صورت ماهانه انجام خواهد شد',
  day: 'روز'
}
